import { useAuth } from "auth"
import { BonzaiProvider } from "bonzai"
import { ErrorPopup } from "utility-components"
import { DeleteMeView } from "./views/DeleteMeView/DeleteMeView"

export const App = () => (
  <BonzaiProvider>
    <AppWrapper />
  </BonzaiProvider>
)

const AppWrapper = () => {
  const { isPending, error } = useAuth()

  if (isPending) return null
  if (error) return <ErrorPopup error={error} />

  return <DeleteMeView />
}
